import { TeamRoleService } from '../../services/team-role/team-role.service';
import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Subject} from 'rxjs';
import {IptPhase} from '../../model/team/IptPhase';
import {GetTeamRoles} from '../../services/team-role/GetTeamRoles';
import {TeamRoleUtil} from '../../TeamRoleUtil';
import {AbstractInputDirective} from '../AbstractInputDirective';

@Component({
  selector: 'digires-role-input',
  templateUrl: './role-input.component.html',
  styleUrls: ['./role-input.component.scss']
})
export class RoleInputComponent extends AbstractInputDirective implements OnInit, OnDestroy, OnChanges {
  readonly destroy$: Subject<boolean> = new Subject<boolean>();

  @Output() onSelected = new EventEmitter<GetTeamRoles>();
  @Input() phase: IptPhase;

  util: TeamRoleUtil;
  allRoles: GetTeamRoles[];
  filteredRoles: GetTeamRoles[];

  constructor(
    private roleService: TeamRoleService,
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.roleService
      .fetchAllTeamRoles()
      .then(list => {
        this.allRoles = list;
        this.filteredRoles = list;
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    this.util = new TeamRoleUtil(this.phase);
  }

  getRoleNameForRole(role: any): string {
    if (role?.name) {
      return role.name;
    }
    return role;
  }

  isRoleMandatory(role: GetTeamRoles): boolean {
    return this.util.isMandatory(role);
  }

  isConstructionRoleCore(role: GetTeamRoles): boolean {
    return role.settings[IptPhase.CONSTRUCTION].core;
  }

  onFilterRoles(event: any): void {
    const value = event.target.value;
    if (!value) {
      this.onRoleSelected(undefined);
      return;
    }
    const lowerCaseVal: string = value.toLowerCase();
    this.filteredRoles = this.allRoles.filter(role => {
      return role.name.toLowerCase().includes(lowerCaseVal);
    });

    const foundOpt = this.filteredRoles.find(role => {
      return role.name.toLowerCase() === lowerCaseVal;
    });
    if (foundOpt) {
      this.onRoleSelected(foundOpt);
    }
  }

  onRoleSelected(value: GetTeamRoles): void {
    this.filteredRoles = this.allRoles;
    this.patch(value);
    this.onSelected.emit(value);
  }

}
